import { Component, Input } from '@angular/core';
import { SideNavItem } from '../sidenav-data';

@Component({
  selector: 'app-sidenav-menu-item',
  templateUrl: './sidenav-menu-item.component.html',
  styleUrls: ['./sidenav-menu-item.component.scss']
})
export class SidenavMenuItemComponent {
  @Input() item: SideNavItem;
  @Input() showText: boolean;
  @Input() showTooltip: boolean;
  constructor() {}
}
